const SITE_URL: string = "https://chianva.sonbook.net";

const BRAND_NAME: string = "千華駐科技";

const LOGO_PATH: string =
  "https://storage.readdy-site.link/project_files/6517ebfd-0186-45e8-a53b-6a7dda87aef3/6d23f5d8-f2c4-4070-a39b-51782f265262_compressed_logo-02.webp";

const IN_LANGUAGE: string = "zh-TW";

export const siteConfig = {
  url: SITE_URL,
  brandName: BRAND_NAME,
  logoUrl: LOGO_PATH,
  inLanguage: IN_LANGUAGE,

  routes: {
    home: "/",
    about: "/about",
    stores: "/stores",
    faq: "/faq",
  } as const,

  absoluteUrl(path: string): string {
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    return `${SITE_URL}${normalizedPath}`;
  },
} as const;